// eslint-disable-next-line
export enum BenefitStates {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
